import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/arrow-circle-right-outline-blue.svg'


const _hoisted_1 = { class: "wrap-list-verpal-report" }
const _hoisted_2 = { class: "header-ctn" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "flex gap-4 items-center" }
const _hoisted_5 = { class: "flex gap-1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"20px"}
}, null, -1)
const _hoisted_7 = { class: "text-grey-5 font-bold text-sm" }
const _hoisted_8 = { class: "table-verpal-report verbal-section" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Tanggal"),
  /*#__PURE__*/_createElementVNode("th", null, "Judul Verbal"),
  /*#__PURE__*/_createElementVNode("th", null, "Kontroller"),
  /*#__PURE__*/_createElementVNode("th", null, "Kondektur"),
  /*#__PURE__*/_createElementVNode("th", null, "Kategori Laporan"),
  /*#__PURE__*/_createElementVNode("th", null, "Status"),
  /*#__PURE__*/_createElementVNode("th")
], -1)
const _hoisted_10 = { style: {"min-width":"150px","max-width":"280px"} }
const _hoisted_11 = { class: "font-semibold" }
const _hoisted_12 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(".. ")
const _hoisted_14 = { class: "text-primary font-extrabold" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = {
  class: "flex gap-4 items-center pl-4",
  style: {"border-left":"1px solid #ECEFF1"}
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "text-sm font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatusVerbalChip = _resolveComponent("StatusVerbalChip")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_HjpCofirmModal = _resolveComponent("HjpCofirmModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(`Jadwal: ${_ctx.dataItem?.CodeSchedule}`), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.dataItem?.RoutesCityName), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("table", null, [
        _hoisted_9,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataItem?.Verbals, (verbal, idx) => {
          return (_openBlock(), _createElementBlock("tr", { key: idx }, [
            _createElementVNode("td", null, _toDisplayString(_ctx.moment(verbal.CreatedAt).format('DD-MM-YYYY')), 1),
            _createElementVNode("td", null, _toDisplayString(verbal.Title), 1),
            _createElementVNode("td", null, _toDisplayString(verbal.Controller.ControllerName), 1),
            _createElementVNode("td", null, _toDisplayString(verbal.Controller.Rit?.TransactionPp.CondecturName), 1),
            _createElementVNode("td", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(`${verbal.VerbalConstraints.map((category) => category.ConstraintName).slice(0, 2).join(', ')}`), 1),
              (verbal.VerbalConstraints.length > 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("span", _hoisted_14, "+" + _toDisplayString(verbal.VerbalConstraints.slice(2,
                verbal.VerbalConstraints.length).length) + " Kategori lainnya", 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_StatusVerbalChip, {
                status: (verbal?.MsStatus.Name as StatusVerbal),
                code: (verbal?.MsStatus.Code as StatusVerbalCode)
              }, null, 8, ["status", "code"])
            ]),
            _createElementVNode("td", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", {
                  class: "text-primary font-extrabold cursor-pointer",
                  onClick: ($event: any) => (_ctx.onDetail(verbal))
                }, " Lihat Detail ", 8, _hoisted_17),
                _createElementVNode("i", {
                  class: "pi pi-ellipsis-h cursor-pointer text-lg font-extrabold",
                  style: {"color":"#000000"},
                  onClick: ($event: any) => (_ctx.showDropDown($event, verbal))
                }, null, 8, _hoisted_18)
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_OverlayPanel, { ref: "opStatus" }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus.filter((val) => val.label !== _ctx.selectedItem?.MsStatus.Code), (item, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex mb-2 items-center gap-2 cursor-pointer",
              key: idx,
              onClick: ($event: any) => (_ctx.onChangeStatus(item))
            }, [
              _createElementVNode("div", {
                class: "flex rounded-full w-2 h-2",
                style: _normalizeStyle({ backgroundColor: item.color })
              }, null, 4),
              _createElementVNode("p", _hoisted_20, _toDisplayString(item.label), 1)
            ], 8, _hoisted_19))
          }), 128))
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_HjpCofirmModal, {
      show: _ctx.attrModalConfirmation.show,
      imgContent: _ctx.attrModalConfirmation.imgContent,
      title: _ctx.attrModalConfirmation.title,
      subTitle: _ctx.attrModalConfirmation.subTitle,
      btnSubmitTitle: _ctx.attrModalConfirmation.btnSubmitTitle,
      onHideDialog: _ctx.hideDialogConfirmation
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "onHideDialog"])
  ]))
}